import { parseUnits } from 'ethers';

const MAX_RAW_AMOUNT = (1n << 128n) - 1n;

export function parseNearDisplayAmount(value: string, decimals: number, {allowZero = false}: {allowZero?: boolean} = {}): string {
  const text = value.trim();
  if (!/^(0|[1-9][0-9]*)(\.[0-9]+)?$/.test(text)) throw new Error('Enter a positive decimal amount.');
  if (!Number.isInteger(decimals) || decimals < 0 || decimals > 24) throw new Error('Unsupported asset decimals.');
  let amount: bigint;
  try { amount = parseUnits(text, decimals); }
  catch { throw new Error(`Use no more than ${decimals} decimal places.`); }
  if (amount < 0n || !allowZero && amount === 0n || amount > MAX_RAW_AMOUNT) throw new Error('Amount is outside the supported raw-unit range.');
  return amount.toString();
}
